import { useV2GetAccountQuery } from "@generated";

const useAccountHasEnetitlement = () => {
  const {
    data: account,
    isLoading,
    isError,
  } = useV2GetAccountQuery({});

  const hasEntitlement = (entitlementToCheck: string): boolean => {
    const entitlements = account?.data?.attributes?.entitlements ?? [];

    return entitlements.some((entitlement) => {
      return entitlementToCheck === entitlement;
    });
  };

  return { hasEntitlement, isLoading, isError, account };
};

export default useAccountHasEnetitlement;
